import { FunctionComponent, useMemo } from 'react';
import { renderPrice } from '../../services/renderPrice';

export type CostProps = {
    currency?: 'GBP' | 'EUR' | 'USD' | 'AUD' | 'CAD';
    value: number;
};

export const Cost: FunctionComponent<CostProps> = ({ value, currency = 'GBP' }) => {
    const formattedValue = useMemo(() => {
        if (isNaN(value)) {
            return '';
        }
        return renderPrice(value, currency);
    }, [value, currency]);
    return <>{formattedValue}</>;
};
